import type {AxiosRequestConfig} from 'axios';
import {ActionServiceRetrieve, ActionServiceScheduleOrders} from './interface';

export class RetrieveRubikaOrdersRequestBuilder {
  private readonly actionResponseRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/action/retrieve-rubika-orders',
    data: {},
  };

  data(data: ActionServiceRetrieve) {
    this.actionResponseRequest.data = data;
    return this;
  }

  build() {
    return this.actionResponseRequest;
  }
}

export class ScheduleOrdersRequestBuilder {
  private readonly actionResponseRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/action/schedule-orders',
    data: {},
    params: {},
  };

  params(data: ActionServiceScheduleOrders) {
    this.actionResponseRequest.params = data;
    return this;
  }

  build() {
    return this.actionResponseRequest;
  }
}

export class InitRequestBuilder {
  private readonly actionResponseRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/ticket-management/config',
    data: {},
  };

  params(data: ActionServiceScheduleOrders) {
    this.actionResponseRequest.params = data;
    return this;
  }

  build() {
    return this.actionResponseRequest;
  }
}
